import type {
  CarouselSlidePaddingType,
  CarouselSlidesVisibleTypeDesktop,
  CarouselSlidesVisibleTypeMobile,
  CarouselSlidesVisibleTypeTablet,
} from "./types";

// The slide counts and slide padding the editor offers. The carousel
// (hec/components/ui/carousel) has a class for each, plus the code-only peek
// counts "3.25" and "2.25", which the editor lists leave out.
export const slidesVisibleValuesDesktop: CarouselSlidesVisibleTypeDesktop[] = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
];
export const slidesVisibleValuesTablet: CarouselSlidesVisibleTypeTablet[] = [
  "1",
  "2",
  "3",
  "4",
];
export const slidesVisibleValuesMobile: CarouselSlidesVisibleTypeMobile[] = [
  "1",
  "2",
  "3",
];

// Numeric gap scale (matches composable: Array.from({length: 7}, (_, i) => i.toString()))
export const slidePaddingValues: CarouselSlidePaddingType[] = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
];
